import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import { Flex, Box } from 'rebass';
import Checkbox from '../../../Checkbox';

const RefinementItem = ({
  refine,
  currentRefinement,
  attribute,
  indicator,
  label,
}) => {
  const isChecked = currentRefinement[0] === 'Yes';
  return (
    <Checkbox
      id={`checkbox-${attribute}`}
      label={
        <Flex alignItems="center">
          <Box mr={1} style={{ display: 'inline-flex' }}>
            {indicator}
          </Box>{' '}
          {label}
        </Flex>
      }
      checked={isChecked}
      onChange={() => {
        refine(isChecked ? '' : 'Yes');
      }}
    />
  );
};

export default connectRefinementList(RefinementItem);
